import React from 'react';
import { PortfolioSizeInput } from '@/components/portfolio/build/PortfolioSizeInput';
import { PortfolioCurrencySelect } from '@/components/portfolio/build/PortfolioCurrencySelect';
import { PortfolioSizeLockToggle } from '@/components/portfolio/build/PortfolioSizeLockToggle';

interface PortfolioSizeControlsProps {
  portfolioId: string;
  type?: string;
  isMobile: boolean;
  portfolioSize: number;
  onPortfolioSizeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  totalAllocations: number;
  hasOverflow: boolean;
  onAutoSize?: (targetSize?: number) => void;
  isLocked: boolean;
  currency: string;
  onCurrencyChange: (code: string) => void;
  isSaving: boolean;
}

export function PortfolioSizeControls({
  portfolioId,
  type,
  isMobile,
  portfolioSize,
  onPortfolioSizeChange,
  totalAllocations,
  hasOverflow,
  onAutoSize,
  isLocked,
  currency,
  onCurrencyChange,
  isSaving,
}: PortfolioSizeControlsProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end gap-4">
      <div className="flex-1">
        <PortfolioSizeInput
          portfolioSize={portfolioSize}
          onPortfolioSizeChange={onPortfolioSizeChange}
          totalAllocations={totalAllocations}
          hasOverflow={hasOverflow}
          onAutoSize={type !== 'model' ? onAutoSize : undefined}
          isLocked={isLocked}
          currency={currency}
        />
      </div>
      {type !== 'model' && (
        <div className="w-[140px]">
          <PortfolioCurrencySelect
            portfolioId={portfolioId}
            value={currency}
            onChange={onCurrencyChange}
            label="Currency"
          />
        </div>
      )}
      <div className="flex items-center gap-2">
        {isSaving && (
          <span className="text-xs text-muted-foreground">Saving...</span>
        )}
        {type !== 'model' && (
          <div className={isMobile ? '' : 'pb-1'}>
            <PortfolioSizeLockToggle portfolioId={portfolioId} />
          </div>
        )}
      </div>
    </div>
  );
}
